<div class="row pad-bottom-16">
  <div class="column twelve">
    <h2 class="heading-main" dsContent [contentPath]="'policy.policyChangePageHeader'"></h2>
    <p
      dsContent
      [contentPath]="'policy.policyChangeHeading'"
      [options]="{ amfamUrl: amfamDotComUrl + 'privacy-security' }"
    ></p>
  </div>
</div>

<form [formGroup]="changeRequestForm">
  <div class="row">
    <fieldset id="personal-info" class="column twelve md-six pad-bottom-16">
      <legend
        class="pad-vertical-10"
        dsContent
        [contentPath]="'policy.policyChangeTypeSelectionHeading'"
      ></legend>
      <ds-form-control-container
        [labelText]="policyChangeTypeLabel"
        [control]="typeInput"
        [boldLabel]="true"
      >
        <select
          id="typeInput"
          class="icon fill"
          (change)="onTypeChange($event.target.value)"
          formControlName="typeInput"
          data-cy="requestChangeSelect"
        >
          <option value=""></option>
          @for (changeItem of requestChangeTypeValues | keyvalue: sortFn; track changeItem) {
            <option [value]="changeItem.value">
              {{ changeItem.key }}
            </option>
          }
        </select>
        <span class="icon-chevron-down"></span>
        <ds-form-control-message [control]="typeInput"></ds-form-control-message>
      </ds-form-control-container>
    </fieldset>
  </div>
  <!-- NameGroup Form -->
  @if (selectedMethodType === PolicyChangeRequestType.NAME_CHANGE) {
    <div>
      <ds-change-request-name-form
        [firstName]="firstName"
        [lastName]="lastName"
        (changeRequestName)="handleNameAddress($event)"
        (valueChangeEvent)="handlevalueChangeEvent()"
        (cancelEvent)="handleCancelEvent()"
      ></ds-change-request-name-form>
    </div>
  }

  @if (selectedMethodType === PolicyChangeRequestType.VIN_CHANGE && newTemplate) {
    <div>
      <ds-change-request-vin
        [newTemplate]="newTemplate"
        [agents]="agents"
        [vehicles]="risks || []"
        [years]="years"
        [vinInfo]="vinInfo"
        (changeRequestVin)="handleVinChange($event)"
        (valueChangeEvent)="handlevalueChangeEvent()"
        (cancelEvent)="handleCancelEvent()"
      ></ds-change-request-vin>
    </div>
  }

  @if (selectedMethodType === PolicyChangeRequestType.ADDRESS_CHANGE && !newTemplate) {
    <div>
      <ds-change-request-address-form
        [currentAddress]="currentAddress"
        [newTemplate]="newTemplate"
        (changeRequestAddress)="handleNameAddress($event)"
        (valueChangeEvent)="handlevalueChangeEvent()"
        (cancelEvent)="handleCancelEvent()"
      ></ds-change-request-address-form>
    </div>
  }

  @if (
    selectedMethodType === PolicyChangeRequestType.ADDRESS_CHANGE && addressInfo && newTemplate
  ) {
    <div>
      <ds-change-request-address-form
        [currentAddress]="currentAddress"
        [agents]="agents"
        [addressInfo]="addressInfo"
        [risks]="risks || []"
        [newTemplate]="newTemplate"
        (changeRequestAddress)="handleNameAddress($event)"
        (valueChangeEvent)="handlevalueChangeEvent()"
        (cancelEvent)="handleCancelEvent()"
      ></ds-change-request-address-form>
    </div>
  }

  @if (selectedMethodType === PolicyChangeRequestType.DRIVER_LICENSE_CHANGE && newTemplate) {
    <div>
      <ds-change-request-driver-license
        [driverLicense]="driverLicense"
        [agents]="agents"
        [drivers]="drivers"
        (changeRequestDriverLicense)="handleLicenseChange($event)"
        (valueChangeEvent)="handlevalueChangeEvent()"
        (cancelEvent)="handleCancelEvent()"
      ></ds-change-request-driver-license>
    </div>
  }
  <!-- PoliciesGroup Form -->
  @if (selectedMethodType === PolicyChangeRequestType.POLICY_COVERAGE_CHANGE) {
    <div>
      <ds-plchangerequest-policies
        [policyList]="policyList"
        (changeRequestPolicies)="handlePolicies($event)"
        (cancelEvent)="handleCancelEvent()"
        (valueChangeEvent)="handlevalueChangeEvent()"
      >
      </ds-plchangerequest-policies>
    </div>
  }

  <!-- Edit Mortgage lender details Form -->
  @if (
    tpiRequestChangeEnabled &&
    selectedMethodType === PolicyChangeRequestType.MORTGAGE_LENDER_DETAILS_CHANGE
  ) {
    <div>
      <ds-change-request-mortgage-lender-details
        [policyList]="policyList"
        [propertyPolicies]="propertyPolicies"
        (changeRequestLender)="handleMortgageLenderChanges($event)"
        (cancelEvent)="handleCancelEvent()"
        (valueChangeEvent)="handlevalueChangeEvent()"
      >
      </ds-change-request-mortgage-lender-details>
    </div>
  }
</form>

<ds-modal
  [id]="modalId"
  [closeOthers]="true"
  [maxWidth]="800"
  (onCloseModalEvent)="closeModal(selectedMethodType)"
>
  <div class="row">
    <div class="column twelve">
      <h2
        class="pad-bottom-20 pad-left-50 pad-right-50 text-center font-weight-semibold"
        dsContent
        [contentPath]="'policy.changeTypeConfirmationText'"
      ></h2>
      <p
        class="pad-bottom-20 text-center font-weight-semibold"
        dsContent
        [contentPath]="'policy.changeTypeConfirmationMessage'"
      ></p>
      <div class="flex items-center">
        <button
          ds-button
          (click)="onChange(changeRequestSelectedType)"
          class="-error"
          type="button"
          dsContent
          [contentPath]="'shared.confirmBtn'"
        ></button>
        <a
          (click)="closeModal(selectedMethodType)"
          class="pad-left-20 caption primary-800-text font-weight-bold"
          dsContent
          [contentPath]="'shared.cancel'"
        ></a>
      </div>
    </div>
  </div>
</ds-modal>
